import { render } from "./TopBarNotifications.vue?vue&type=template&id=790911af&scoped=true"
import script from "./TopBarNotifications.vue?vue&type=script&lang=js"
export * from "./TopBarNotifications.vue?vue&type=script&lang=js"

import "./TopBarNotifications.vue?vue&type=style&index=0&id=790911af&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-790911af"]])

export default __exports__